import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';
import { AppConstants } from '../../constants/AppConstants';
import { Utils, domainVal, NumberFormatter, i18n, DateFormatter, domain, isAuth } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import ProdottoActions from './prodotto_actions';
import ApplicationData from '../../app/aApplicationData';

class OperazioneTable extends React.Component {
    constructor(props) {
        super(props);
        // this.detailsOnClick = this.detailsOnClick.bind(this);
        this.componentName = '[OperazioneTable.jsx] ';

        this.state = {
            showConfirm: false,
            showConfirmModifica: false,
            operazioneDaModificare: {},
        }
        this.modificaProdottoOperazione = this.modificaProdottoOperazione.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.showConfirmPanelModifica = this.showConfirmPanelModifica.bind(this);
        this.checkBoxChangeHandler = this.checkBoxChangeHandler.bind(this);

    }


    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        let columns = [];
        if (this.props.source && this.props.source === "prodottoCreate") {
            columns = [
                { checkbox: true, field: "checked", visible: this.props.source && this.props.source === "prodottoCreate" },
                { field: 'codCampo', title: 'Id', sortable: 'true' },
                { field: 'valCampo', title: i18n('ARM_CORE_PRODUCT.SHARED.VALORE', 'Valore'), sortable: 'true' },
                { field: 'desDom', title: i18n('ARM_CORE_PRODUCT.SHARED.DESCRIZIONE', 'Descrizione'), sortable: 'true', },
                { field: 'info', title: i18n('ARM_CORE_PRODUCT.SHARED.INFO', 'Info'), sortable: 'true', },
            ]
        } else {
            columns = [
                { field: 'idProdottoOperazione', title: 'Id', sortable: 'true' },
                { field: 'opeTipoOperazione', title: i18n('ARM_CORE_PRODUCT.SHARED.VALORE', 'Valore'), sortable: 'true', formatter: this.operazioneFormatter },
                { field: 'codQuestionario', title: i18n('ARM_CORE_PRODUCT.OPERAZIONE.COD_QUESTIONARIO', 'Questionario'), sortable: 'true', visible: isAuth('V2.ADMIN.PRODUCT.TAB_OPERAZIONI.VIEW.QUESTIONARIO') },
                { field: 'flTipoBanca', title: i18n('ARM_CORE_PRODUCT.OPERAZIONE.COD_QUESTIONARIO', 'Tipo Iniziativa Banca'), sortable: 'true', formatter: this.formatYesNo, visible: isAuth('V2.ADMIN.PRODUCT.TAB_OPERAZIONI.VIEW.INIZIATIVA') },
                { field: 'flTipoCliente', title: i18n('ARM_CORE_PRODUCT.OPERAZIONE.COD_QUESTIONARIO', 'Tipo Iniziativa Cliente'), sortable: 'true', formatter: this.formatYesNo, visible: isAuth('V2.ADMIN.PRODUCT.TAB_OPERAZIONI.VIEW.INIZIATIVA') },
                { field: 'idUserUpd', title: i18n('ARM_CORE_PRODUCT.SHARED.MODIFICATO_DA', 'Modificato Da'), sortable: 'true', },
                { field: 'dateUpd', title: i18n('ARM_CORE_PRODUCT.SHARED.DATA_UPDATE', 'Data Ultima Modifica'), sortable: 'true', formatter: this.dateFormatter, },
                { field: 'edit', align: 'center', title: i18n("ARM_CORE_PRODUCT.SHARED.MODIFICA", "Modifica"), visible: isAuth('V2.ADMIN.PRODUCT.TAB_OPERAZIONI.VIEW.QUESTIONARIO'), formatter: this.columnEdit },
            ]
        }

        $(this.refs.MyTable).bootstrapTable({
            columns: columns,
            idField: "idProdottoOperazione",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            clickToSelect: true,
            maintainMetaData: true,
            maintainSelected: true,
            onClickRow: (row, $element, field) => this.editOnClick(row, $element, field),
            sortOrder: "desc",
            pagination: true,


        });

        if (this.props.source && this.props.source === "prodottoCreate") {
            this.props.inzializzaModificaOperazioni().then(
                resolve => {
                    if (this.props.operazioni !== null && this.props.operazioni !== undefined) {
                        $(this.refs.MyTable).bootstrapTable('load', this.props.operazioni);
                    }
                }
            )
        } else {
            if (this.props.operazioni !== null && this.props.operazioni !== undefined) {
                $(this.refs.MyTable).bootstrapTable('load', this.props.operazioni);
            }
        }

    }

    formatYesNo(value, row, index) {
        return value == 0 ? 'No' : 'Si';

    }

    dateFormatter(value, row, index) {
        return DateFormatter.dataFormatter(value);
    }

    operazioneFormatter(value, row, index) {
        return ApplicationData.domainVal("AI_TIPO_OPERAZIONE", row.opeTipoOperazione, row.opeTipoOperazione).desDom
    }

    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');

        if (nextProps.operazioni !== this.props.operazioni) {
            console.log("\t rows: " + (nextProps.operazioni !== null ? nextProps.operazioni.length : "NULL"));

            if (nextProps.operazioni === null) {
                $(this.refs.MyTable).bootstrapTable('removeAll');
            } else {
                $(this.refs.MyTable).bootstrapTable('load', nextProps.operazioni);
            }
        }
    }

    inputChangeHandler(e) {
        let id = e.target.id;
        let value = e.target.value;
        let object = this.state.operazioneDaModificare;
        object[id] = value;
        this.setState({ operazioneDaModificare: object });
    }

    checkBoxChangeHandler(e) {
        if (e !== null && e !== undefined) {
            console.log(this.componentName + 'checkBoxChangeHandler');
            let value = e.target.value;
            let id = e.target.id;
            let object = this.state.operazioneDaModificare;
            value = true;
            if (id == 'flTipoCliente' && this.state.operazioneDaModificare.flTipoCliente) {
                value = false;
            }
            if (id == 'flTipoBanca' && this.state.operazioneDaModificare.flTipoBanca) {
                value = false;
            }
            object[id] = value;

            this.setState({ operazioneDaModificare: object });
        }
    }


    modificaProdottoOperazione() {
        if (this.state.operazioneDaModificare) {
            this.showConfirmPanelModifica();
            this.props.modificaProdottoOperazione(this.state.operazioneDaModificare).then(
                resolve => {
                    this.props.getListaOperazioni(this.props.idProdotto)
                }
            )
        }
    }

    showConfirmPanelModifica() {
        this.setState({ showConfirmModifica: !this.state.showConfirmModifica });
    }

    columnEdit(value, row, index) {
        console.log(this.componentName + " columnEdit: " + index);
        let temp;
        temp = "<button class='btn btn-primary btn-sm'><i class='fas fa-edit fa-fw' data-toggle='tooltip' data-placement='top' title='Modifica'/></button>";
        return temp;
    }
    
    editOnClick(row, $element, field) {
        if (field === "edit") {
            if(row.ordine == null){
                let ordine = this.props.setOrdineVisibilitaOperazioni(row);
                row.ordine = ordine;
            }
            this.setState({
                operazioneDaModificare: row,
                showConfirmModifica: true
            });

        }


    }

    render() {
        console.log(this.componentName + ' render');
        return (
            <div className="card-body">
                <table ref="MyTable" className={AppConstants.CLASS_TABLE} />

                <agui.ConfirmModalOkCancelV4 show={this.state.showConfirmModifica} >
                    <agui.ConfirmModalOkCancelV4.Header testoTitle={i18n("ARM_CORE_PRODUCT.SHARED.MODIFICA", "Modifica")} onClose={this.showConfirmPanelModifica} />
                    <agui.ConfirmModalOkCancelV4.Body>
                        <div className="row mt-1 mb-3 ">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ATextInputV4
                                    id="codQuestionario"
                                    type="text"
                                    value={this.state.operazioneDaModificare && this.state.operazioneDaModificare.codQuestionario}
                                    label={i18n('ARM_CORE_PRODUCT.PRODOTTO.OPERAZIONE.QUESTIONARIO', 'Questionario')}
                                    onChange={this.inputChangeHandler}
                                    name="codQuestionario"
                                />
                            </div>
                        </div>
                        <div className="row mt-1 mb-3 ">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ATextInputV4
                                    id="codQuestionarioCliente"
                                    type="text"
                                    value={this.state.operazioneDaModificare && this.state.operazioneDaModificare.codQuestionarioCliente}
                                    label={i18n('ARM_CORE_PRODUCT.PRODOTTO.OPERAZIONE.QUESTIONARIO_CLIENTE', 'Questionario cliente')}
                                    onChange={this.inputChangeHandler}
                                    name="codQuestionarioCliente"
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <p className="ml-3">{i18n('ARM_CORE_PRODUCT.PRODOTTO.OPERAZIONE.INIZIATIVA', 'Tipo iniziativa: ')}</p>
                            <div className="row  ml-3">
                                <div className="col col-sm-1 col-md-1 col-lg-1">
                                    <agui.aToggleV4
                                        id="flTipoBanca"
                                        label={i18n('ARM_CORE_PRODUCT.PRODOTTO.OPERAZIONE.BANCA', 'Banca')}
                                        type="NO"
                                        value={this.state.operazioneDaModificare && this.state.operazioneDaModificare.flTipoBanca}
                                        checked={this.state.operazioneDaModificare.flTipoBanca}
                                        onChange={this.checkBoxChangeHandler}
                                    />
                                </div>
                            </div>
                            <div className="row  ml-3">
                                <div className="col col-sm-1 col-md-1 col-lg-1">
                                    <agui.aToggleV4
                                        id="flTipoCliente"
                                        label={i18n('ARM_CORE_PRODUCT.PRODOTTO.OPERAZIONE.CLIENTE', 'Cliente ')}
                                        type="NO"
                                        value={this.state.operazioneDaModificare && this.state.operazioneDaModificare.flTipoCliente}
                                        checked={this.state.operazioneDaModificare.flTipoCliente}
                                        onChange={this.checkBoxChangeHandler}
                                    />
                                </div>
                            </div>

                        </div>


                        <div className="row mt-1 mb-3">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ATextInputV4
                                    id={"ordine"}
                                    type="number"
                                    value={this.state.operazioneDaModificare.ordine}
                                    name="ordine"
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.POSIZIONE', 'Ordine Visibilità')}
                                    onChange={this.inputChangeHandler}
                                />
                            </div>
                        </div>


                    </agui.ConfirmModalOkCancelV4.Body >
                    <agui.ConfirmModalOkCancelV4.Footer
                        testoButtonConfirm={i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}
                        confirmOnClick={this.modificaProdottoOperazione}
                        onClose={this.showConfirmPanelModifica}>
                    </agui.ConfirmModalOkCancelV4.Footer>
                </agui.ConfirmModalOkCancelV4>

            </div>
        );
    }
};




function mapDispatchToProps(dispatch) {
    return {

        setOrdineVisibilitaOperazioni(row) {
            return dispatch(ProdottoActions.setOrdineVisibilitaOperazioni(row));
        },
    }
};
function mapStateToProps(state) {
    return {

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(OperazioneTable);

